<template>
  <div class="home">
    <div class="home-header">
      <span class="home-tip">按住 Ctrl / ⌘ + 滚轮可缩放，拖拽画布可平移</span>
    </div>
    <div ref="graphContainer" class="graph-container"></div>
  </div>
</template>

<script>
import { createModelingGraph, resizeModelingGraph } from '@/utils/modelingGraph'

export default {
  name: 'ExcelModel',
  props: {
    jsonData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      graph: null,
    }
  },
  mounted() {
    // 等待容器完成布局后再初始化画布
    this.onResize = this.debounce(() => {
      resizeModelingGraph(this.graph, this.$refs.graphContainer)
    }, 150)
    this.$nextTick(() => {
      this.initGraph()
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    if (this.graph) {
      this.graph.dispose()
      this.graph = null
    }
  },
  methods: {
    initGraph() {
      if (!this.$refs.graphContainer) return
      this.graph = createModelingGraph(this.$refs.graphContainer, this.jsonData)
    },
    // 简单防抖，避免窗口 resize 频繁触发
    debounce(fn, delay) {
      let timer = null
      return function (...args) {
        clearTimeout(timer)
        timer = setTimeout(() => fn.apply(this, args), delay)
      }
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.home-header {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  padding: 0 0 12px 0;
}

.home-tip {
  font-size: 12px;
  color: #94a3b8;
}

.graph-container {
  max-width: 1200px;
  max-height: 900px;
  border-radius: 10px;
}
</style>
